import { CustomerType } from "@origin-digital/platform-enums";
import { CommonParameters, IMcAppType, NavFlow, Tab } from "../mcApp.types";

export const internetUsage: IMcAppType = {
  name: "internetUsage",
  path: "/my/internet/usage",
  description: "Internet Usage",
  parameters: {
    properties: {
      accountNumber: CommonParameters.superloopAccountNumber,
    },
  },
  navFlow: NavFlow.STANDARD,
  title: "Usage",
  parent: Tab.DASHBOARD,
  conditions: {
    intent: "internetUsage",
    customerType: CustomerType.kraken,
  },
};
